import { t } from "../lib/i18n";
import LanguageSwitcher from "./LanguageSwitcher";
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

const PublicNavbar: React.FC = () => {
  return (
    <nav className="bg-white/95 backdrop-blur-md border-b border-slate-200/80 px-6 md:px-12 py-3 flex justify-between items-center w-full sticky top-0 z-50 shadow-sm">
      <div className="flex items-center">
        <Link to="/" className="flex items-center no-underline">
          <img
            src={logo}
            alt={t("publicNavbar.k1")}
            className="h-20 sm:h-24 md:h-28 w-auto object-contain hover:opacity-95 transition-opacity"
          />
        </Link>
      </div>

      <div className="flex items-center gap-3 md:gap-6 text-sm font-semibold">
        <Link to="/" className="text-slate-700 hover:text-blue-600 transition-colors no-underline">
          {t("publicNavbar.k2")} </Link>
        <Link to="/#deal-screener" className="text-slate-700 hover:text-blue-600 transition-colors no-underline hidden sm:inline">
          {t("publicNavbar.k3")} </Link>
        <Link to="/blog" className="text-slate-700 hover:text-blue-600 transition-colors no-underline">
          {t("publicNavbar.k4")} </Link>
        <Link to="/about" className="text-slate-700 hover:text-blue-600 transition-colors no-underline">
          About
        </Link>
        <Link to="/contact" className="text-slate-700 hover:text-blue-600 transition-colors no-underline hidden sm:inline">
          {t("publicNavbar.k5")} </Link>
        <LanguageSwitcher />
        <Link
          to="/login"
          className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg shadow-sm transition-all no-underline"
        >
          {t("publicNavbar.k6")} </Link>
      </div>
    </nav>
  );
};

export default PublicNavbar;
